import styled from "styled-components";

import * as Grid from "@ui/Atoms/Grid";

import { ScrollZone } from "../../Components";

export const Root = styled(Grid.Container)`
  padding-top: ${({ theme }) => theme.spacing.spacing_32};
  padding-bottom: ${({ theme }) => theme.spacing.spacing_32};

  ${props => props.theme.breakpoints.tablet} {
    padding-top: ${({ theme }) => theme.spacing.spacing_64};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_32};
  }

  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_80};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_48};
  }

  &:has(h2) {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.spacing_32};
  }
`;

export const Benefit = styled(ScrollZone.SlideContainer)`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_12};
  width: 300px;

  ${props => props.theme.breakpoints.tablet} {
    width: 311px;
  }

  ${props => props.theme.breakpoints.desktop} {
    width: 288px;
  }

  ${props => props.theme.breakpoints.desktopLarge} {
    width: 356px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_8};
  flex: 1;
`;
